/**
 * Libs
 * */
import dynamic from 'next/dynamic';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hooks
 * */
import { useSidebar } from 'src/features/common/app/hooks/use-sidebar';

/**
 * Types
 * */
import {
    ISectionConfiguration,
    WizardStateAbout,
} from 'src/features/common/universe-wizard/context/wizard-context.types';

const AboutSidebarContainer = dynamic(() => import('../containers/about-universe-sidebar-container'), {
    ssr: false,
});

export const useRenderAboutSidebar = ({
    title,
    fullDescription,
    ...props
}: ISectionConfiguration<WizardStateAbout>) => {
    const { render } = useSidebar();
    const { t } = useTranslation(['pages']);

    return useCallback(() => {
        render(
            t('home.universeAbout.title', { title }),
            // @ts-ignore
            <AboutSidebarContainer {...props} fullDescription={fullDescription} />
        );
    }, [fullDescription, props, render, t, title]);
};
